import { DateTime } from "effect";

export function humanizeDate(d: DateTime.Utc): string {
  return DateTime.formatUtc(d, { year: "numeric", month: "short", day: "2-digit" });
}
